import React from 'react';
import { PropTypes } from 'prop-types';
import styled, { css } from 'styled-components';

import { Text, FontWeight } from './Text';
import TouchableText from './TouchableText';
import { Colors } from '../constants';

const propTypes = {
  emptyStateText: PropTypes.any,
  actionText: PropTypes.string,
  onActionClick: PropTypes.func,
  lineBreak: PropTypes.bool,
};

const defaultProps = {
  emptyStateText: '',
  actionText: '',
  onActionClick: () => { },
  lineBreak: false,
};

const dashedMixin = css`
  padding: 12px;
  border: 1px dashed ${Colors.GRAY};
  border-radius: 8px;
  text-align: center;
`;

const borderSolidMixin = css`
  background-color: white;
  border: 1px solid ${Colors.GRAY_LIGHTER};
  border-radius: 8px;
  padding: 22px;
`;

const alignCenterMixin = css`
  justify-content: center;
  display: flex;
`;

const EmptyStateWithActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;

  ${({ dashed }) => dashed && dashedMixin}
  ${({ borderSolid }) => borderSolid && borderSolidMixin}
  ${({ alignCenter }) => alignCenter && alignCenterMixin}
`;

const EmptyStateTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

const EmptyStateText = styled(Text)`
  font-weight: 400;
  font-size: 16px;
  color: ${Colors.PRIMARY_DARK};
  text-align: center;
`;

const EmptyStateDescription = styled(Text)`
  font-weight: 400;
  font-size: 12px;
  color: ${Colors.GRAY_DARKER};
  text-align: center;
`;

const StyledTouchableText = styled(TouchableText)`
  margin-left: 8px;
  font-size: 16px;
`;

const EmptyStateWithAction = ({
  emptyStateText,
  emptyStateDescription,
  renderAction,
  actionText,
  lineBreak,
  onActionClick,
  ...props
}) => (
  <EmptyStateWithActionContainer {...props}>
    <EmptyStateTextWrapper>
      <EmptyStateText>
        {emptyStateText}
      </EmptyStateText>
      {emptyStateDescription ?
        (
          <EmptyStateDescription>
            {emptyStateDescription}
          </EmptyStateDescription>
        )
        : null
      }
    </EmptyStateTextWrapper>
    {lineBreak && <br />}
    {renderAction ? renderAction() : null}
    {actionText && onActionClick && !renderAction && (
      <StyledTouchableText
        weight={FontWeight.Bold}
        underline
        onClick={(e) => {
          e.stopPropagation();
          onActionClick();
        }}
      >
        {actionText}
      </StyledTouchableText>
    )}
  </EmptyStateWithActionContainer>
);

EmptyStateWithAction.propTypes = propTypes;
EmptyStateWithAction.defaultProps = defaultProps;

export default EmptyStateWithAction;
